import { FC, JSX } from "react";
import ContentLoader, { Rect } from "react-content-loader/native";

export interface ISkeletonProps {
  height?: string;
}

const Skeleton: FC<ISkeletonProps> = ({ height = "15" }): JSX.Element => {

  return (
    <>
      <ContentLoader className="flex justify-start items-start" viewBox="0 0 380 25">
        <Rect x="0" y="10" rx="4" ry="4" width="70%" height={height} />
      </ContentLoader>
    </>
  );
};

export default Skeleton;
